import {styled} from '@linaria/react';
import React from 'react';
import {LoadingSpinner} from './LoadingSpinner';

interface LoadingPageSpinnerProps {
  className?: string;
  'data-testid'?: string;
}

export const LoadingPageSpinner = ({
  className,
  'data-testid': testId,
  ref,
}: LoadingPageSpinnerProps & {ref?: React.Ref<HTMLDivElement>}) => {
  return (
    <Wrapper ref={ref} className={className} data-testid={testId}>
      <LoadingSpinner />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75vh;
`;
